import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;
  align-items: center;
  gap: 24px;

  ${mediaQueries.tablet} {
    gap: 48px;
    grid-auto-flow: column;
  }
`

export const Heading = styled.div`
  font-size: 32px;
  font-weight: 600;
  line-height: 1.2;
`

export const Description = styled.div`
  margin-top: 8px;
  line-height: 1.5;
`

export const Video = styled.div`
  position: relative;

  display: flex;

  align-items: center;
  justify-content: center;

  aspect-ratio: 16/9;
  cursor: pointer;

  ${mediaQueries.tablet} {
    height: 180px;
  }
`

export const VideoThumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  object-fit: cover;

  border-radius: 4px;
`
